import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { MechanismSection } from './components/MechanismSection';
import { SolutionSection } from './components/SolutionSection';
import { WhyOthersFail } from './components/WhyOthersFail';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  // Smooth scroll behavior
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);
  return <div className="min-h-screen bg-[#faf8f5] text-[#2d2d2d] font-sans selection:bg-[#c9a227] selection:text-white" data-id="element-0">
      {/* Navigation / Header - Simple for landing page */}
      <nav className="absolute top-0 left-0 w-full z-50 py-6" data-id="element-1">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-2">
          <div className="text-2xl font-serif font-bold text-[#1a4d3e]" data-id="element-3">
            Metabo-Reset<span className="text-[#c9a227]" data-id="element-4">40+</span>
          </div>
          <button className="text-[#1a4d3e] font-semibold hover:text-[#c9a227] transition-colors text-sm md:text-base" data-id="element-5">
            Acceso Miembros
          </button>
        </div>
      </nav>

      <main data-id="element-6">
        <HeroSection data-id="element-7" />
        <PainPointsSection data-id="element-8" />
        <MechanismSection data-id="element-9" />
        <SolutionSection data-id="element-10" />
        <WhyOthersFail data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}